import { checkForVaiControllerTransactionError } from 'errors';
import type { TransactionReceipt } from 'web3-core';
import { VaiController, UmiVault, DlVault } from 'types/contracts';

export interface IsetRoiInput {
  dlControllerContract: DlVault;
  fromAccountAddress: string;
  amountWei: string;
}

export type IsetRoiOutput = TransactionReceipt;

const setRoi = async ({
  dlControllerContract,
  fromAccountAddress,
  amountWei,
}: IsetRoiInput): Promise<IsetRoiOutput> => {
  const resp = await dlControllerContract.methods
    .setRoi(amountWei)
    .send({ from: fromAccountAddress });
  return checkForVaiControllerTransactionError(resp);
};

export default setRoi;
